// extracted by mini-css-extract-plugin
export default {"label":"SelectType_label__jf2T2","select":"SelectType_select__xhANi","selectError":"SelectType_selectError__on6ch"};